export default __webpack_public_path__ + "static/media/home-preview-app-showcase.bc4fa913.jpg";